var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconFileRequest = function SvgIconFileRequest(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 21.333.513 2.667C.513 1.468 1.458.5 2.653.5h18.68c1.19 0 2.167.976 2.167 2.167v18.666c0 1.19-.976 2.167-2.167 2.167H2.653A2.155 2.155 0 0 1 .5 21.333M16.473 16.5h5.36V2.167H2.153V16.5h5.374c.25 2.254 2.166 4 4.473 4a4.505 4.505 0 0 0 4.473-4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconFileRequest);
export { ForwardRef as ReactComponent };